import QnaBuyerSupport from '../QnaBuyerSupport/QnaBuyerSupport';

const Footer = () => {
  return (
    <footer data-testid='footer'>
      <QnaBuyerSupport renderBorderTop />
    </footer>
  );
};

export default Footer;
